// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"413fb66d","160":"97ec6095","208":"c25f6854","293":"667cacdc","453":"70860a9e","493":"0ecf68db","516":"8c106ab3","519":"ee2b68c9","917":"eb462839","946":"5e1ffb60"}[chunkId] + ".chunk.js";
};